import React from 'react';
import PropTypes from 'prop-types';
import {Spinner} from '../Spinner';

import './style.css';

export const LoadingScreen = (props) => {
    return (
        <section className="hero is-fullheight alva-bg">
            <div className="hero-body">
                <div className="container">
                    <div className="loading-container">
                        <Spinner noMargin={true}/>
                        <div>
                            {props.children}
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};


LoadingScreen.propTypes = {
    children: PropTypes.oneOfType([
        PropTypes.element, PropTypes.array
    ])
};

export default LoadingScreen;
